import { z } from 'zod';

export const ReviewItemSummaryTaskSchema = z.object({}).optional();

export type ReviewItemSummaryTaskSchemaType = z.infer<
  typeof ReviewItemSummaryTaskSchema
>;
